module.exports = __webpack_public_path__ + "img/el-m-out75.6d86e625.png";